import { render, staticRenderFns } from "./announcement-dialog.vue?vue&type=template&id=6b003d2d&scoped=true"
import script from "./announcement-dialog.vue?vue&type=script&lang=js"
export * from "./announcement-dialog.vue?vue&type=script&lang=js"
import style0 from "./announcement-dialog.vue?vue&type=style&index=0&id=6b003d2d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b003d2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b003d2d')) {
      api.createRecord('6b003d2d', component.options)
    } else {
      api.reload('6b003d2d', component.options)
    }
    module.hot.accept("./announcement-dialog.vue?vue&type=template&id=6b003d2d&scoped=true", function () {
      api.rerender('6b003d2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/announcement-dialog/announcement-dialog.vue"
export default component.exports